<template>
    <v-card class="pa-4" flat>
        <v-row justify="center">
            <v-col cols="12" class="text-right">
                <TableMedien :showTitle="false" ref="table" :companyId="companyId" :isCompanyView="true"/>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    // import Vue from 'vue'
    import TableMedien from "../../tables/TableMedien"
    export default {
        name: 'TabMedien',
        components: {TableMedien},
        props: {
            companyId: String
        },
        methods: {
            open: function () {
            },
            reload: function () {
                this.$refs.table.reload()
            }
        },
        data () {
            return {}
        },
        mounted () {

        }
    }
</script>

<style scoped>

</style>
